export default {
  setFreight(state, freight) {
    state.freight = freight || {};
  },
};
